module.exports = __webpack_public_path__ + "static/media/consulta-mobile.f0892418.png";